import { queryOptions, useQuery } from '@tanstack/react-query'

import { commentApi } from '../api/commentApi'

export const getCommentResponsesOptions = (commentId: number, enabled?: boolean) =>
  queryOptions({
    queryKey: ['comment_responses', commentId],
    queryFn: ({ signal }) => commentApi.getResponses(commentId, { signal }),
    retry: 0,
    staleTime: 60 * 1000 * 10, // 10 minutes
    enabled,
  })

export const useCommentResponsesQuery = (commentId: number, enabled?: boolean) =>
  useQuery(getCommentResponsesOptions(commentId, enabled))
